export const isArray = (value: unknown): value is unknown[] => {
  return Object.prototype.toString.call(value) === '[object Array]';
};

export const isStringArray = (value: unknown): value is string[] => {
  if (!isArray(value)) return false;
  for (let i = 0; i < value.length; i++) {
    if (typeof value[i] !== 'string') return false;
  }
  return true;
};
